export default {
  label: "In Development",
  notAvailable: "not available",
  pending: "pending",
};
